import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Universal Collapsible Accordion Component
 * Reusable for FAQ sections, technical specifications, and process guides.
 */
export default function Accordion({ items, allowMultiple = false, className = '' }) {
  const [openIndexes, setOpenIndexes] = useState([0]);

  const toggleIndex = (idx) => {
    if (allowMultiple) {
      setOpenIndexes(prev => 
        prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]
      );
    } else {
      setOpenIndexes(prev => prev.includes(idx) ? [] : [idx]);
    }
  };

  return (
    <div className={`space-y-3 ${className}`}>
      {items.map((item, idx) => {
        const isOpen = openIndexes.includes(idx);
        return (
          <div
            key={idx}
            className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-2xs transition-all duration-200"
          >
            <button
              type="button"
              onClick={() => toggleIndex(idx)}
              className="w-full p-4 sm:p-5 text-left flex items-center justify-between gap-4 cursor-pointer hover:bg-gray-50/50"
              aria-expanded={isOpen}
            >
              <span className="text-xs sm:text-sm font-bold text-[#0f172a]">{item.title || item.q}</span>
              <ChevronDown className={`w-4 h-4 text-[#00796b] shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen && (
              <div className="px-4 sm:px-5 pb-5 pt-1 text-xs text-gray-600 leading-relaxed border-t border-gray-100">
                {item.content || item.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
